module.exports = __webpack_public_path__ + "img/rs.ec5ecd0c.png";